import { ethers } from 'ethers';
import contractAbi from '../ABI/contractAbi.json';
import { CHAIN_ID, CONTRACT_ADDRESS } from '../constants/constants';
import { getActiveProvider } from './walletProvider';
import { normalizeChainId } from './walletRequests';

/**
 * Подписант из подключённого кошелька, с проверкой сети.
 *
 * Сеть проверяется прямо перед подписью, а не только при подключении: её
 * могли переключить в кошельке, и транзакция ушла бы в чужую сеть.
 */
export async function getSigner(): Promise<ethers.JsonRpcSigner> {
  const wallet = getActiveProvider();

  if (!wallet) {
    throw new Error('Кошелёк не подключён. Подключите кошелёк и повторите.');
  }

  const provider = new ethers.BrowserProvider(wallet);
  const network = await provider.getNetwork();

  if (normalizeChainId(network.chainId) !== CHAIN_ID) {
    throw new Error(
      'Кошелёк не в сети BSC. Переключите сеть и повторите операцию.',
    );
  }

  return provider.getSigner();
}

export const getContract = async () =>
  new ethers.Contract(CONTRACT_ADDRESS, contractAbi, await getSigner());
